import {
	mapState,
	mapActions
} from 'vuex';

export default {
	name: 'student-highlight-messages',
	computed: {
		...mapState({
			classLevel: (state) => state.Class.selected.schoolClassLevel,
			messagesGroups: (state) => state.Inbox.inboxAgenda
		})
	},
	methods: {
		...mapActions([
			'getMessages'
		]),
		replyMessage(messageGroup) {

			this.$router.push({
				name: 'ReplyMessage',
				params: {
					id: messageGroup
				}
			});

		}
	},
	mounted() {

		this.getMessages();

	}
};



// WEBPACK FOOTER //
// ./sources/domains/agenda/highlight/messages/index.js